import SectionHeading from "@/components/base/SectionHeading";

const steps = [
  {
    no: "01",
    icon: "ri-edit-2-line",
    title: "提交线索",
    desc: "通过投稿表单或私信通道，把掌握的内幕、证据或素材发给我们。是否留下联系方式，完全由你决定。",
  },
  {
    no: "02",
    icon: "ri-lock-2-line",
    title: "加密存证",
    desc: "材料入库即做加密处理，投稿人身份信息单独保管，仅在核实确有需要时按最小范围调阅。",
  },
  {
    no: "03",
    icon: "ri-search-eye-line",
    title: "交叉核实",
    desc: "与多个独立来源比对时间、地点与细节，必要时向当事方发出问询，确认哪些内容站得住脚。",
  },
  {
    no: "04",
    icon: "ri-send-plane-line",
    title: "安全发布",
    desc: "做匿名化处理后发布，明确标注核实状态；后续如有新进展，会在同一页面更新而非另起新稿。",
  },
];

export default function SubmitProcess() {
  return (
    <section className="border-y border-foreground-950/10 bg-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="投稿流程"
          title="一条线索，要走完这四步"
          desc="我们把流程做得尽量透明，是为了让投稿人清楚自己的材料会被怎么对待，也让读者知道每一条爆料是怎么被核实出来的。"
        />

        <ol className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <li key={step.no} className="relative">
              <div className="flex items-center gap-3">
                <span className="font-heading text-3xl font-black leading-none text-primary-500">{step.no}</span>
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-foreground-800">
                  <i className={`${step.icon} text-xl`} aria-hidden="true"></i>
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}